import classes from './index.module.css';

export const WarningTips = ({ text }) => (
  <div className={classes.warning_tips_wrapper}>
    <div className={classes.warning_tips}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_15292_32678)">
          <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM7.2 4.8C7.2 4.35817 7.55817 4 8 4C8.44183 4 8.8 4.35817 8.8 4.8V8C8.8 8.44183 8.44183 8.8 8 8.8C7.55817 8.8 7.2 8.44183 7.2 8V4.8ZM8 12C8.44183 12 8.8 11.6418 8.8 11.2C8.8 10.7582 8.44183 10.4 8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2C7.2 11.6418 7.55817 12 8 12Z" fill="#FC9952" />
        </g>
        <defs>
          <clipPath id="clip0_15292_32678">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {text}
    </div>
  </div>
);

export const MessageTips = ({ message }) => (
  <div className={classes.message_tips_wrapper}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={classes.message_icon}>
      <g clipPath="url(#clip0_443_1115)">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 -4.82049e-07 10 0C4.486 4.82049e-07 -4.82049e-07 4.486 0 10C4.82049e-07 15.514 4.486 20 10 20ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V10C9 9.44772 9.44771 9 10 9C10.5523 9 11 9.44772 11 10V14ZM10 5C9.44771 5 9 5.44771 9 6C9 6.55229 9.44771 7 10 7C10.5523 7 11 6.55229 11 6C11 5.44771 10.5523 5 10 5Z" fill="#00A0AC" />
      </g>
      <defs>
        <clipPath id="clip0_443_1115">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <div>{message}</div>
  </div>
);
